import { OrderEntryEffects } from './order-entry.effects';
import { RatingEffects } from './rating.effects';
import { ShippingBookedEffects } from './shipping-booked.effects';
import { ShippingDeliveredEffects } from './shipping-delivered.effects';
import { ShippingLoadAuditLogEffects } from './shipping-load-audit-logs.effects';
import { ShippingLoadDetailEffects } from './shipping-load-detail.effects';
import { ShippingPostedEffects } from './shipping-posted.effects';

export const effects: any[] = [
  ShippingLoadDetailEffects,
  ShippingPostedEffects,
  ShippingBookedEffects,
  ShippingDeliveredEffects,
  ShippingLoadAuditLogEffects,
  OrderEntryEffects,
  RatingEffects,
];

export * from './shipping-booked.effects';
export * from './shipping-delivered.effects';
export * from './shipping-load-audit-logs.effects';
export * from './shipping-load-detail.effects';
export * from './shipping-posted.effects';
